import React, { useEffect, useState } from 'react'

import { Icon, Input, INPUT_THEME, Select } from '@st-operations/uikit/src/v2/index.js'

import SignalsCollapsible from '../signals-collapsible'
import SeedsTable from '../seeds-block/SeedsTable'

import {
  getLookalikeAudienceSeedsEnum,
  getLookalikeAudienceSeedsWithFilters,
} from '_services/audience'

import '../seeds-block/styles.scss'

const SeedsBlock = ({ audience, setAudience }) => {
  const [createdByOptions, setCreatedByOptions] = useState([])
  const [createdBy, setCreatedBy] = useState('')
  const [seedsSearch, setSeedsSearch] = useState('')

  const [selectedSeed, setSelectedSeed] = useState(
    audience?.userIdSeed?._id ? audience.userIdSeed : null
  )
  const [reloadCollapsible, setReloadCollapsible] = useState(0)

  useEffect(() => {
    getLookalikeAudienceSeedsEnum().then((resp) => setCreatedByOptions(resp))
  }, [])

  useEffect(() => {
    if (selectedSeed) {
      setAudience((prev) => ({
        ...prev,
        userIdSeed: selectedSeed,
      }))
    }
  }, [selectedSeed])

  const removeSeed = () => {
    setSelectedSeed(null)
    setAudience((prev) => ({
      ...prev,
      userIdSeed: {},
    }))
  }

  const handleSearchSeedsInputChange = (value) => {
    setSeedsSearch(value)
  }

  const handleSelectCreatedBy = (newData) => {
    setCreatedBy(newData?.value)
  }

  return (
    <SignalsCollapsible
      name="User ID Seeds"
      dependencies={{ audience, reloadCollapsible }}
      className="ac-seeds-block"
      resume={audience?.userIdSeed?.name}
    >
      <div className="ac-seeds-block__input-container">
        <p className="ac-seeds-block__title">Select a seed from the list below</p>
        <div className="ac-seeds-block__filters">
          <Input
            name="seeds"
            label="Search"
            placeholder="Search for user ID seeds"
            onChange={handleSearchSeedsInputChange}
            value={seedsSearch}
            theme={INPUT_THEME.SEARCH}
          />
          <Select
            name="created_by"
            label="Created By"
            value={createdBy}
            options={createdByOptions}
            onChange={handleSelectCreatedBy}
            useReactSelect
            isClearable={true}
          />
        </div>
        <If condition={selectedSeed}>
          <div className="ac-seeds-block__selected-seed">
            Selected Seed: {selectedSeed.name}
            <button className="ac-seeds-block__remove-seed" onClick={removeSeed}>
              <Icon icon="trashcan" type="outline" width={16} height={16} color="#13682b" />
            </button>
          </div>
        </If>
      </div>
      <SeedsTable
        query={seedsSearch}
        createdBy={createdBy}
        selectedSeed={selectedSeed}
        setSelectedSeed={setSelectedSeed}
        setReloadCollapsible={setReloadCollapsible}
        removeSeed={removeSeed}
        getSeeds={getLookalikeAudienceSeedsWithFilters}
      />
    </SignalsCollapsible>
  )
}

export default SeedsBlock
